var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowYourself(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 44,
    fill: "#FFF8E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0714 30.9286H45.5V34.7857H30.0714V30.9286ZM30.0714 23.2143H53.2143V27.0714H30.0714V23.2143ZM30.0714 15.5H53.2143V19.3571H30.0714V15.5Z",
    fill: "#F0B518"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7284 65.6429L34.5881 46.3649L48.9251 58.8813C49.3585 59.2669 49.8733 59.5499 50.4312 59.709C50.9891 59.8681 51.5757 59.8994 52.1473 59.8004C52.7189 59.7014 53.2609 59.4748 53.7328 59.1373C54.2047 58.7999 54.5944 58.3603 54.8729 57.8514L68.315 37.7885L65.1116 35.6401L51.6116 55.7898L51.4766 55.9884L37.1377 43.472C36.7045 43.0885 36.1906 42.8073 35.6341 42.6491C35.0776 42.4908 34.4926 42.4596 33.9224 42.5577C33.3523 42.6558 32.8114 42.8808 32.3398 43.2159C31.8682 43.5511 31.4779 43.9879 31.1977 44.4941L22.3571 60.2101V15.5H18.5V65.6429C18.5 66.6658 18.9064 67.6469 19.6297 68.3703C20.3531 69.0936 21.3342 69.5 22.3571 69.5H72.5V65.6429H23.7284Z",
    fill: "#F0B518"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowYourself);
export default __webpack_public_path__ + "static/media/know_yourself.9f5ff183014880718d27ce251353314a.svg";
export { ForwardRef as ReactComponent };